import WhatsappSignup from 'components/settings/containers/sections/whatsapp/whatsappSignup';
export const SettingsMessagingWhatsAppSetupView = WhatsappSignup;
